/**
 * AT ギャラリー Lightbox
 * AT_top_gallery / AT_about_gallery 用
 * Lightbox2 互換（jQuery非依存・バニラJS）
 * 必要な機能のみ実装：画像プリロード、アスペクト比に応じたコンテナアニメーション
 */
(function() {
  'use strict';
  if (window.__atGalleryLightboxLoaded) return;
  window.__atGalleryLightboxLoaded = true;

  var options = {
    wrapAround: true,
    albumLabel: '%1 / %2',
    showImageNumberLabel: true,
    fitImagesInViewport: true,
    resizeDuration: 700,
    fadeDuration: 600,
    imageFadeDuration: 600,
    positionFromTop: 50,
    disableScrolling: true
  };
  window.lightbox = window.lightbox || {};
  window.lightbox.option = function(opts) {
    if (opts) Object.assign(options, opts);
  };

  var containerPadding = { top: 0, right: 0, bottom: 0, left: 0 };
  var imageBorderWidth = { top: 4, right: 4, bottom: 4, left: 4 };

  function build() {
    if (document.getElementById('lightbox')) return;
    var html = '<div id="lightboxOverlay" class="lightboxOverlay"></div><div id="lightbox" class="lightbox"><div class="lb-outerContainer"><div class="lb-closeContainer"><a class="lb-close" href="#" role="button" aria-label="閉じる" tabindex="0"></a></div><div class="lb-container"><img class="lb-image" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" alt=""/><div class="lb-loader"><span class="lb-loader-spinner"></span></div><div class="lb-nav"><a class="lb-prev" href="#"></a><a class="lb-next" href="#"></a></div></div></div><div class="lb-dataContainer"><div class="lb-data"><div class="lb-details"><span class="lb-caption"></span><span class="lb-number"></span></div></div></div></div>';
    var div = document.createElement('div');
    div.innerHTML = html;
    while (div.firstChild) {
      document.body.appendChild(div.firstChild);
    }
    bindEvents();
  }

  var album = [], currentIndex = 0, preloader = null, isOpen = false;
  var overlay, lightboxEl, outerContainer, dataContainer, imgEl, loaderEl, captionEl, numberEl, prevBtn, nextBtn;
  var resizeTimeout = null;
  var savedScrollY = 0;

  function getEl() {
    overlay = document.getElementById('lightboxOverlay');
    lightboxEl = document.getElementById('lightbox');
    outerContainer = lightboxEl && lightboxEl.querySelector('.lb-outerContainer');
    dataContainer = lightboxEl && lightboxEl.querySelector('.lb-dataContainer');
    imgEl = lightboxEl && lightboxEl.querySelector('.lb-image');
    loaderEl = lightboxEl && lightboxEl.querySelector('.lb-loader');
    captionEl = lightboxEl && lightboxEl.querySelector('.lb-caption');
    numberEl = lightboxEl && lightboxEl.querySelector('.lb-number');
    prevBtn = lightboxEl && lightboxEl.querySelector('.lb-prev');
    nextBtn = lightboxEl && lightboxEl.querySelector('.lb-next');
  }

  function fadeIn(el, duration, done) {
    el.style.display = 'block';
    el.style.transition = 'opacity ' + (duration / 1000) + 's ease';
    el.style.opacity = '0';
    el.offsetHeight;
    el.style.opacity = '1';
    if (done) setTimeout(done, duration);
  }

  function fadeOut(el, duration, done) {
    el.style.transition = 'opacity ' + (duration / 1000) + 's ease';
    el.style.opacity = '0';
    setTimeout(function() {
      el.style.display = 'none';
      if (done) done();
    }, duration);
  }

  function show() {
    if (options.disableScrolling) {
      savedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.body.style.top = '-' + savedScrollY + 'px';
      document.body.classList.add('lb-disable-scrolling');
    }
    lightboxEl.style.top = options.positionFromTop + 'px';
    lightboxEl.style.left = '0';
    fadeIn(overlay, options.fadeDuration);
    fadeIn(lightboxEl, options.fadeDuration);
  }

  function hide(done) {
    if (options.disableScrolling) {
      document.body.classList.remove('lb-disable-scrolling');
      document.body.style.top = '';
      /* base.css の html { scroll-behavior: smooth } でアニメーションが走らないよう instant を明示 */
      window.scrollTo({ top: savedScrollY, left: 0, behavior: 'instant' });
    }
    fadeOut(overlay, options.fadeDuration);
    fadeOut(lightboxEl, options.fadeDuration, done || function() {});
  }

  function sizeContainer(imageWidth, imageHeight) {
    var newWidth = imageWidth + containerPadding.left + containerPadding.right + imageBorderWidth.left + imageBorderWidth.right;
    var newHeight = imageHeight + containerPadding.top + containerPadding.bottom + imageBorderWidth.top + imageBorderWidth.bottom;
    var oldWidth = outerContainer.offsetWidth;
    var oldHeight = outerContainer.offsetHeight;

    function postResize() {
      if (dataContainer) dataContainer.style.width = newWidth + 'px';
      outerContainer.classList.remove('animating');
      showImage();
    }

    outerContainer.style.transition = 'width ' + (options.resizeDuration / 1000) + 's ease, height ' + (options.resizeDuration / 1000) + 's ease';
    outerContainer.style.width = newWidth + 'px';
    outerContainer.style.height = newHeight + 'px';

    if (oldWidth !== newWidth || oldHeight !== newHeight) {
      setTimeout(postResize, options.resizeDuration);
    } else {
      postResize();
    }
  }

  function showImage() {
    if (loaderEl) loaderEl.style.display = 'none';
    imgEl.style.opacity = '0';
    imgEl.style.display = 'block';
    imgEl.style.transition = 'opacity ' + (options.imageFadeDuration / 1000) + 's ease';
    imgEl.offsetHeight;
    imgEl.style.opacity = '1';
    updateNav();
    updateDetails();
    preloadNeighboringImages();
    if (dataContainer) {
      dataContainer.style.display = '';
      dataContainer.style.opacity = '0';
      dataContainer.style.transition = 'opacity ' + (options.resizeDuration / 1000) + 's ease';
      dataContainer.offsetHeight;
      dataContainer.style.opacity = '1';
    }
    outerContainer.classList.remove('animating');
  }

  function updateNav() {
    var showPrev = options.wrapAround || currentIndex > 0;
    var showNext = options.wrapAround || currentIndex < album.length - 1;
    prevBtn.style.display = showPrev ? '' : 'none';
    nextBtn.style.display = showNext ? '' : 'none';
  }

  function updateDetails() {
    var item = album[currentIndex];
    captionEl.innerHTML = item.title || '';
    captionEl.style.display = item.title ? '' : 'none';
    if (album.length > 1 && options.showImageNumberLabel) {
      numberEl.textContent = options.albumLabel.replace(/%1/g, currentIndex + 1).replace(/%2/g, album.length);
      numberEl.style.display = '';
    } else {
      numberEl.style.display = 'none';
    }
  }

  function preloadNeighboringImages() {
    if (currentIndex < album.length - 1) {
      var nextImg = new Image();
      nextImg.src = album[currentIndex + 1].link;
    }
    if (currentIndex > 0) {
      var prevImg = new Image();
      prevImg.src = album[currentIndex - 1].link;
    }
  }

  function changeImage(index) {
    currentIndex = index;
    var item = album[index];
    if (!item) return;

    if (preloader) {
      preloader.onload = null;
      preloader.onerror = null;
    }

    outerContainer.classList.add('animating');
    if (loaderEl) loaderEl.style.display = 'block';
    imgEl.style.display = 'none';
    imgEl.style.opacity = '0';
    prevBtn.style.display = 'none';
    nextBtn.style.display = 'none';
    if (dataContainer) dataContainer.style.display = 'none';

    var img = new Image();
    preloader = img;

    img.onload = function() {
      if (img !== preloader) return;
      var w = img.naturalWidth || img.width;
      var h = img.naturalHeight || img.height;
      var maxW = window.innerWidth - containerPadding.left - containerPadding.right - imageBorderWidth.left - imageBorderWidth.right - 20;
      var maxH = window.innerHeight - containerPadding.top - containerPadding.bottom - imageBorderWidth.top - imageBorderWidth.bottom - options.positionFromTop - 70;

      var imageWidth = w, imageHeight = h;
      if (options.fitImagesInViewport && (w > maxW || h > maxH)) {
        if ((w / maxW) > (h / maxH)) {
          imageWidth = maxW;
          imageHeight = Math.round(h / (w / imageWidth));
        } else {
          imageHeight = maxH;
          imageWidth = Math.round(w / (h / imageHeight));
        }
      }

      imgEl.src = item.link;
      imgEl.alt = item.alt || '';
      imgEl.width = imageWidth;
      imgEl.height = imageHeight;

      sizeContainer(imageWidth, imageHeight);
    };

    img.onerror = function() {
      if (img !== preloader) return;
      if (loaderEl) loaderEl.style.display = 'none';
      outerContainer.classList.remove('animating');
    };

    img.src = item.link;
  }

  function handleResize() {
    if (!isOpen || album.length === 0 || !imgEl) return;
    var w = imgEl.naturalWidth || imgEl.width;
    var h = imgEl.naturalHeight || imgEl.height;
    if (!w || !h || (w <= 1 && h <= 1)) return;

    outerContainer.classList.add('animating');
    if (loaderEl) loaderEl.style.display = 'block';
    imgEl.style.display = 'none';
    imgEl.style.opacity = '0';
    prevBtn.style.display = 'none';
    nextBtn.style.display = 'none';
    if (dataContainer) dataContainer.style.display = 'none';

    var maxW = window.innerWidth - containerPadding.left - containerPadding.right - imageBorderWidth.left - imageBorderWidth.right - 20;
    var maxH = window.innerHeight - containerPadding.top - containerPadding.bottom - imageBorderWidth.top - imageBorderWidth.bottom - options.positionFromTop - 70;

    var imageWidth = w, imageHeight = h;
    if (options.fitImagesInViewport && (w > maxW || h > maxH)) {
      if ((w / maxW) > (h / maxH)) {
        imageWidth = maxW;
        imageHeight = Math.round(h / (w / imageWidth));
      } else {
        imageHeight = maxH;
        imageWidth = Math.round(w / (h / imageHeight));
      }
    }

    imgEl.width = imageWidth;
    imgEl.height = imageHeight;
    sizeContainer(imageWidth, imageHeight);
  }

  function onResize() {
    if (resizeTimeout) clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      resizeTimeout = null;
      if (lightboxEl && document.getElementById('lightbox')) {
        getEl();
        handleResize();
      }
    }, 100);
  }

  function start(trigger) {
    var group = trigger.getAttribute('data-lightbox') || trigger.getAttribute('rel');
    var links = group ? document.querySelectorAll('a[data-lightbox="' + group + '"], a[rel="' + group + '"]') : [trigger];
    album = [];
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      album.push({
        link: a.href,
        title: a.getAttribute('data-title') || a.getAttribute('title') || '',
        alt: a.getAttribute('data-alt') || ''
      });
      if (a === trigger) currentIndex = i;
    }
    if (album.length === 0) return;
    isOpen = true;
    show();
    changeImage(currentIndex);
    window.addEventListener('resize', onResize);
  }

  function end() {
    isOpen = false;
    window.removeEventListener('resize', onResize);
    if (resizeTimeout) {
      clearTimeout(resizeTimeout);
      resizeTimeout = null;
    }
    document.removeEventListener('keyup', onKeyup);
    if (preloader) {
      preloader.onload = null;
      preloader.onerror = null;
      preloader = null;
    }
    hide();
  }

  function onKeyup(e) {
    if (e.keyCode === 27) {
      e.stopPropagation();
      end();
    } else if (e.keyCode === 37) {
      if (currentIndex > 0) changeImage(currentIndex - 1);
      else if (options.wrapAround && album.length > 1) changeImage(album.length - 1);
    } else if (e.keyCode === 39) {
      if (currentIndex < album.length - 1) changeImage(currentIndex + 1);
      else if (options.wrapAround && album.length > 1) changeImage(0);
    }
  }

  function bindEvents() {
    getEl();
    overlay.addEventListener('click', function(e) { end(); e.preventDefault(); });
    lightboxEl.addEventListener('click', function(e) {
      if (e.target.id === 'lightbox') { end(); e.preventDefault(); }
    });
    prevBtn.addEventListener('click', function(e) {
      e.preventDefault();
      if (currentIndex === 0 && options.wrapAround) changeImage(album.length - 1);
      else changeImage(currentIndex - 1);
    });
    nextBtn.addEventListener('click', function(e) {
      e.preventDefault();
      if (currentIndex === album.length - 1 && options.wrapAround) changeImage(0);
      else changeImage(currentIndex + 1);
    });
    lightboxEl.querySelector('.lb-close').addEventListener('click', function(e) { end(); e.preventDefault(); });
    lightboxEl.querySelector('.lb-close').addEventListener('keyup', function(e) {
      if (e.keyCode === 13 || e.keyCode === 32) { end(); e.preventDefault(); }
    });
  }

  document.addEventListener('click', function(e) {
    var target = e.target.closest('a[data-lightbox], a[rel^="lightbox"]');
    if (target) {
      e.preventDefault();
      build();
      getEl();
      start(target);
      document.addEventListener('keyup', onKeyup);
    }
  });
})();
